module.exports = __webpack_public_path__ + "6eb305c47e2930e1a6ea0c7ce2720846.svg";